<div class="client-page">

  <div class="lx-page-header">
    <div style="display:flex;align-items:center;gap:12px;">
      <button class="back-btn" (click)="goBack()">
        <span class="material-symbols-outlined">arrow_back</span>
      </button>
      <div>
        <p class="lx-page-eyebrow">{{ 'page.users_eyebrow' | translate }}</p>
        <h2 class="lx-page-title">{{ user?.name || user?.username }}</h2>
      </div>
    </div>
    <button class="ud-delete-btn" *ngIf="isSuperAdmin" (click)="confirmDelete()">
      <span class="material-symbols-outlined">delete</span>
      {{ 'btn.delete_user' | translate }}
    </button>
  </div>

  <div class="ud-confirm-overlay" *ngIf="showDeleteConfirm">
    <div class="ud-confirm-card app-card">
      <span class="material-symbols-outlined ud-confirm-icon">warning</span>
      <h3>{{ 'user.delete_confirm' | translate }}</h3>
      <p>{{ 'user.delete_msg' | translate }} <strong>{{ user?.username }}</strong></p>
      <div class="ud-confirm-actions">
        <button class="ud-btn-secondary" (click)="cancelDelete()">{{ 'btn.cancel' | translate }}</button>
        <button class="ud-delete-btn" (click)="deleteUser()">{{ 'btn.delete' | translate }}</button>
      </div>
    </div>
  </div>

  <div class="lx-section-header">
    <span class="material-symbols-outlined">edit</span>
    <h3 class="lx-section-title">{{ 'user.edit_info' | translate }}</h3>
  </div>

  <div class="app-card ud-form-card">
    <form [formGroup]="editForm" (ngSubmit)="saveEdit()">
      <div class="ud-form-grid">
        <div class="ud-field">
          <label class="ud-label">{{ 'lbl.name' | translate }}</label>
          <input class="ud-input" formControlName="name" placeholder="Full name" />
        </div>
        <div class="ud-field">
          <label class="ud-label">{{ 'lbl.username' | translate }}</label>
          <input class="ud-input" formControlName="username" placeholder="username" />
        </div>
        <div class="ud-field ud-field-full">
          <label class="ud-label">{{ 'lbl.email' | translate }}</label>
          <input class="ud-input" formControlName="email" type="email" placeholder="email@example.com" />
        </div>
        <div class="ud-field ud-field-full">
          <label class="ud-label ud-toggle-label">
            <span>{{ 'user.admin_priv' | translate }}</span>
            <label class="ud-switch">
              <input type="checkbox" formControlName="is_admin" />
              <span class="ud-slider"></span>
            </label>
          </label>
          <p class="ud-hint">{{ 'user.admin_hint' | translate }}</p>
        </div>
      </div>
      <div class="ud-form-actions" *ngIf="isSuperAdmin">
        <button type="submit" class="ud-btn-primary" [disabled]="editForm.invalid">{{ 'btn.save_changes' | translate }}</button>
      </div>
    </form>
  </div>

  <div class="lx-section-header" *ngIf="isSuperAdmin">
    <span class="material-symbols-outlined">lock_reset</span>
    <h3 class="lx-section-title">{{ 'user.reset_pw' | translate }}</h3>
  </div>

  <div class="app-card ud-form-card" *ngIf="isSuperAdmin">
    <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
      <div class="ud-form-grid">
        <div class="ud-field ud-field-full">
          <label class="ud-label">{{ 'lbl.new_password' | translate }}</label>
          <input class="ud-input" formControlName="new_password" type="password" [placeholder]="'user.min_pw' | translate" />
        </div>
      </div>
      <div class="ud-form-actions">
        <button type="submit" class="ud-btn-primary" [disabled]="resetPasswordForm.invalid">{{ 'user.reset_pw' | translate }}</button>
      </div>
    </form>
  </div>

</div>
